module.exports = __webpack_public_path__ + "media/images/selectionBet__decoPickWinner-1b26e4fd56e314cddaae7f593cfb7ef6.png";